import { render, staticRenderFns } from "./PriceForLabel.vue?vue&type=template&id=67a3e09c&"
import script from "./PriceForLabel.vue?vue&type=script&lang=js&"
export * from "./PriceForLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports